module.exports = __webpack_public_path__ + "static/media/delle-donne-matias.e5601770.jpg";